import { render, staticRenderFns } from "./weka-data.vue?vue&type=template&id=35909f80&scoped=true&lang=pug"
import script from "./weka-data.vue?vue&type=script&lang=js"
export * from "./weka-data.vue?vue&type=script&lang=js"
import style0 from "./weka-data.vue?vue&type=style&index=0&id=35909f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35909f80",
  null
  
)

export default component.exports